// 명세서 '입금' 표시 공용 (2026-10-23 1단계 §4-4·§5-1·§5-3)
// statementPaymentState(utils/receivables, dev A)의 결과를 화면 글자로 바꾼다.
// 계약상 반환은 'paid'|'partial'|'unpaid' 문자열. 객체({ state, remaining })로 오면 남은 금액도 쓴다.
// 정산(치과 확인)과 입금은 다른 것 — 이 표시는 기공소가 직접 기록한 입금 기준이다.

export const PAYMENT_STATE_LABEL = { paid: '다 받음', partial: '일부', unpaid: '안 받음' };

export const PAYMENT_STATE_STYLE = {
    paid: { background: '#F0FDF4', color: '#15803D', border: '1px solid #BBF7D0' },
    partial: { background: '#FFFBEB', color: '#B45309', border: '1px solid #FDE68A' },
    unpaid: { background: '#F8FAFC', color: '#64748B', border: '1px solid #E2E8F0' },
};

// 원장 대상인 명세서인가 — 살아 있는 발행본 · 치과 거래 · 거래처 키 있음 (명세 §4-4)
export const isLedgerStatement = (s) => !!s
    && (s.status === 'confirmed' || s.status === 'published')
    && s.deletedBySender !== true
    && s.kind !== 'design_outsource' && s.kind !== 'outsource_mf'
    && !!s.toUserId;

// → { state, label, remaining|null } | null
export const paymentStateInfo = (raw) => {
    if (!raw) return null;
    const state = typeof raw === 'string' ? raw : raw.state;
    if (!PAYMENT_STATE_LABEL[state]) return null;
    const remaining = (typeof raw === 'object' && Number.isFinite(Number(raw.remaining))) ? Number(raw.remaining) : null;
    return { state, label: PAYMENT_STATE_LABEL[state], remaining };
};
